<!-- src/views/TiposMembresiaList.vue -->
<template>
  <div class="p-3 md:p-6 bg-gray-50 dark:bg-gray-900 min-h-screen font-sans">
    <!-- Header -->
    <div class="flex flex-col md:flex-row justify-between items-start md:items-center mb-6 gap-4 bg-white dark:bg-gray-800 p-4 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700">
      <div class="flex items-center space-x-3">
        <div class="h-10 w-1.5 bg-gradient-to-b from-indigo-500 to-purple-600 rounded-full"></div>
        <div>
          <h1 class="text-xl md:text-2xl font-bold text-gray-800 dark:text-white flex items-center gap-2">
            <Icon icon="mdi:card-account-details-star" class="text-indigo-600 dark:text-indigo-400" />
            Tipos de Membresía
          </h1>
          <p class="text-xs text-gray-500 dark:text-gray-400 mt-1 flex items-center">
            <Icon icon="mdi:tag-multiple" class="mr-1 text-indigo-500" />
            Planes disponibles para los socios
          </p>
        </div>
      </div>
      <button
        @click="openCreateModal"
        class="bg-indigo-600 hover:bg-indigo-700 text-white px-4 py-2.5 rounded-xl font-bold transition-all shadow-md shadow-indigo-200 dark:shadow-none flex items-center gap-2 text-sm md:text-base"
      >
        <Icon icon="mdi:plus-circle" class="text-lg" />
        Nuevo Tipo
      </button>
    </div>

    <!-- Info de tasa actual -->
    <div v-if="tasaVenta" class="mb-4 bg-gradient-to-r from-emerald-50 to-teal-50 dark:from-emerald-900/20 dark:to-teal-900/20 rounded-xl p-3 border border-emerald-200 dark:border-emerald-800 flex items-center justify-between flex-wrap gap-2">
      <div class="flex items-center gap-2 text-emerald-700 dark:text-emerald-400">
        <Icon icon="mdi:currency-usd" class="text-lg" />
        <span class="text-xs font-bold">Tasa de venta actual:</span>
        <span class="text-sm font-black">Bs {{ formatBs(tasaVenta.precio_usd_bs) }}</span>
        <span v-if="tasaVenta.nombreFuente" class="text-[10px] text-emerald-600 dark:text-emerald-500">
          ({{ tasaVenta.nombreFuente }})
        </span>
      </div>
      <span class="text-[10px] text-emerald-500 flex items-center gap-1">
        <Icon icon="mdi:auto-fix" />
        Los precios en Bs se calculan automáticamente
      </span>
    </div>

    <!-- 🔍 Barra de filtros -->
    <div v-if="tipos.length > 0" class="mb-4 bg-white dark:bg-gray-800 rounded-xl p-3 shadow-sm border border-gray-200 dark:border-gray-700 flex flex-wrap gap-2 items-center justify-between">
      <div class="flex items-center gap-2 flex-1 min-w-[200px]">
        <Icon icon="mdi:magnify" class="text-gray-400" />
        <input v-model="filtroBusqueda" type="text" placeholder="Buscar por código, nombre o descripción..."
          class="flex-1 px-3 py-2 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg text-sm focus:ring-2 focus:ring-indigo-500" />
      </div>
      <div class="flex items-center gap-2">
        <select v-model="filtroEstado" class="px-3 py-2 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg text-sm">
          <option value="">Todos</option>
          <option value="activo">Solo activos</option>
          <option value="inactivo">Solo inactivos</option>
        </select>
        <select v-model="itemsPorPagina" class="px-3 py-2 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg text-sm">
          <option :value="6">6 por página</option>
          <option :value="9">9 por página</option>
          <option :value="12">12 por página</option>
          <option :value="24">24 por página</option>
        </select>
      </div>
    </div>

    <!-- Grid de Tarjetas -->
    <div v-if="cargando" class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      <div v-for="i in 6" :key="'sk'+i" class="bg-white dark:bg-gray-800 rounded-2xl p-5 h-48 animate-pulse"></div>
    </div>

    <div v-else-if="tipos.length === 0" class="bg-white dark:bg-gray-800 rounded-2xl p-12 text-center">
      <Icon icon="mdi:card-off" class="text-6xl text-gray-300 mx-auto mb-4" />
      <p class="text-gray-500 font-bold">No hay tipos de membresía creados</p>
      <p class="text-xs text-gray-400 mt-2">Crea el primero para empezar</p>
    </div>

    <div v-else-if="tiposFiltrados.length === 0" class="bg-white dark:bg-gray-800 rounded-2xl p-12 text-center">
      <Icon icon="mdi:magnify-close" class="text-6xl text-gray-300 mx-auto mb-4" />
      <p class="text-gray-500 font-bold">No hay resultados para "{{ filtroBusqueda }}"</p>
      <button @click="filtroBusqueda = ''; filtroEstado = ''" class="mt-3 text-xs text-indigo-600 underline font-bold">Limpiar filtros</button>
    </div>

    <div v-else>
      <!-- Grid de tarjetas -->
      <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 mb-6">
        <div
          v-for="t in tiposPaginados"
          :key="t.idTipoMembresia"
          :class="[
            'bg-white dark:bg-gray-800 rounded-2xl p-5 shadow-sm border transition-all relative overflow-hidden',
            t.estado === 'activo'
              ? 'border-gray-200 dark:border-gray-700 hover:shadow-lg'
              : 'border-gray-200 dark:border-gray-700 opacity-70 grayscale-[30%]'
          ]"
        >
          <!-- Badge estado -->
          <div class="absolute top-3 right-3">
            <span :class="[
              'px-2 py-0.5 rounded-full text-[10px] font-black uppercase',
              t.estado === 'activo' 
                ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400'
                : 'bg-gray-100 text-gray-500 dark:bg-gray-700'
            ]">
              {{ t.estado || 'activo' }}
            </span>
          </div>

          <!-- Código -->
          <div class="inline-block px-3 py-1 bg-indigo-50 dark:bg-indigo-900/30 rounded-lg mb-3">
            <span class="text-xs font-black text-indigo-600 dark:text-indigo-400">{{ t.codigo }}</span>
          </div>

          <!-- Nombre -->
          <h3 class="text-lg font-black text-gray-800 dark:text-white mb-1">{{ t.nombre }}</h3>
          <p class="text-xs text-gray-500 dark:text-gray-400 mb-3 line-clamp-2 min-h-[32px]">{{ t.descripcion || 'Sin descripción' }}</p>

          <!-- Precio -->
          <div class="mb-3">
            <div class="flex items-end gap-2">
              <span class="text-3xl font-black text-gray-800 dark:text-white">${{ formatUsd(t.precio_usd) }}</span>
              <span class="text-xs text-gray-400 mb-1">/ {{ t.duracion_dias }} días</span>
            </div>
            <div v-if="t.precio_bs > 0" class="mt-1 flex items-center gap-1 text-xs text-emerald-600 dark:text-emerald-400 font-bold">
              <Icon icon="mdi:currency-usd" class="text-xs" />
              Bs {{ formatBs(t.precio_bs) }}
            </div>
          </div>

          <!-- Info adicional -->
          <div class="space-y-1 text-[11px] text-gray-500 dark:text-gray-400 mb-4">
            <div v-if="t.horario_inicio && t.horario_fin" class="flex items-center gap-1">
              <Icon icon="mdi:clock-outline" />
              {{ t.horario_inicio }} - {{ t.horario_fin }}
            </div>
            <div v-if="t.limite_accesos_dia" class="flex items-center gap-1">
              <Icon icon="mdi:counter" />
              Máx. {{ t.limite_accesos_dia }} accesos/día
            </div>
            <div v-else class="flex items-center gap-1">
              <Icon icon="mdi:infinity" />
              Accesos ilimitados
            </div>
          </div>

          <!-- Acciones -->
          <div class="flex gap-2 pt-3 border-t border-gray-100 dark:border-gray-700">
            <button @click="openEditModal(t)" class="flex-1 py-2 bg-indigo-50 dark:bg-indigo-900/20 text-indigo-600 dark:text-indigo-400 rounded-lg text-xs font-bold hover:bg-indigo-100 transition-all flex items-center justify-center gap-1">
              <Icon icon="mdi:pencil" /> Editar
            </button>

            <!-- 🔄 BOTÓN ACTIVAR/DESACTIVAR -->
            <button
              v-if="t.estado === 'activo'"
              @click="confirmToggleEstado(t)"
              class="py-2 px-3 bg-red-50 dark:bg-red-900/20 text-red-600 dark:text-red-400 rounded-lg text-xs font-bold hover:bg-red-100 transition-all flex items-center gap-1"
              title="Desactivar tipo"
            >
              <Icon icon="mdi:power-off" class="text-base" />
              <span class="hidden sm:inline">Desactivar</span>
            </button>
            <button
              v-else
              @click="confirmToggleEstado(t)"
              class="py-2 px-3 bg-emerald-50 dark:bg-emerald-900/20 text-emerald-600 dark:text-emerald-400 rounded-lg text-xs font-bold hover:bg-emerald-100 transition-all flex items-center gap-1"
              title="Activar tipo"
            >
              <Icon icon="mdi:power" class="text-base" />
              <span class="hidden sm:inline">Activar</span>
            </button>
          </div>
        </div>
      </div>

      <!-- 📄 PAGINACIÓN -->
      <div v-if="totalPaginas > 1" class="bg-white dark:bg-gray-800 rounded-2xl shadow-sm border border-gray-200 dark:border-gray-700 p-4 flex flex-col sm:flex-row justify-between items-center gap-3">
        <!-- Info -->
        <div class="text-xs text-gray-500 dark:text-gray-400">
          Mostrando
          <span class="font-bold text-gray-800 dark:text-white">{{ rangoInicio }}</span>
          -
          <span class="font-bold text-gray-800 dark:text-white">{{ rangoFin }}</span>
          de
          <span class="font-bold text-gray-800 dark:text-white">{{ tiposFiltrados.length }}</span>
          planes
        </div>

        <!-- Botones de paginación -->
        <div class="flex items-center gap-1">
          <!-- Primera página -->
          <button
            @click="paginaActual = 1"
            :disabled="paginaActual === 1"
            class="w-9 h-9 flex items-center justify-center rounded-lg border border-gray-200 dark:border-gray-600 text-gray-600 dark:text-gray-400 hover:bg-indigo-50 dark:hover:bg-indigo-900/30 hover:text-indigo-600 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
            title="Primera página"
          >
            <Icon icon="mdi:chevron-double-left" class="text-lg" />
          </button>

          <!-- Anterior -->
          <button
            @click="paginaActual--"
            :disabled="paginaActual === 1"
            class="w-9 h-9 flex items-center justify-center rounded-lg border border-gray-200 dark:border-gray-600 text-gray-600 dark:text-gray-400 hover:bg-indigo-50 dark:hover:bg-indigo-900/30 hover:text-indigo-600 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
            title="Anterior"
          >
            <Icon icon="mdi:chevron-left" class="text-lg" />
          </button>

          <!-- Números de página -->
          <button
            v-for="p in paginasVisibles"
            :key="'p'+p.numero"
            @click="p.numero === '...' ? null : paginaActual = p.numero"
            :disabled="p.numero === '...'"
            :class="[
              'min-w-[36px] h-9 px-3 flex items-center justify-center rounded-lg text-xs font-black transition-all',
              p.numero === paginaActual
                ? 'bg-indigo-600 text-white shadow-md'
                : p.numero === '...'
                  ? 'text-gray-400 cursor-default'
                  : 'border border-gray-200 dark:border-gray-600 text-gray-600 dark:text-gray-400 hover:bg-indigo-50 dark:hover:bg-indigo-900/30 hover:text-indigo-600'
            ]"
          >
            {{ p.numero }}
          </button>

          <!-- Siguiente -->
          <button
            @click="paginaActual++"
            :disabled="paginaActual === totalPaginas"
            class="w-9 h-9 flex items-center justify-center rounded-lg border border-gray-200 dark:border-gray-600 text-gray-600 dark:text-gray-400 hover:bg-indigo-50 dark:hover:bg-indigo-900/30 hover:text-indigo-600 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
            title="Siguiente"
          >
            <Icon icon="mdi:chevron-right" class="text-lg" />
          </button>

          <!-- Última página -->
          <button
            @click="paginaActual = totalPaginas"
            :disabled="paginaActual === totalPaginas"
            class="w-9 h-9 flex items-center justify-center rounded-lg border border-gray-200 dark:border-gray-600 text-gray-600 dark:text-gray-400 hover:bg-indigo-50 dark:hover:bg-indigo-900/30 hover:text-indigo-600 disabled:opacity-30 disabled:cursor-not-allowed transition-all"
            title="Última página"
          >
            <Icon icon="mdi:chevron-double-right" class="text-lg" />
          </button>
        </div>

        <!-- Ir a página -->
        <div class="flex items-center gap-2 text-xs text-gray-500 dark:text-gray-400">
          <span>Ir a:</span>
          <input
            v-model.number="irAPagina"
            @keydown.enter="saltarAPagina"
            type="number"
            min="1"
            :max="totalPaginas"
            class="w-16 px-2 py-1.5 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-lg text-center text-xs font-bold focus:ring-2 focus:ring-indigo-500"
          />
          <button @click="saltarAPagina" class="px-2 py-1.5 bg-indigo-50 dark:bg-indigo-900/30 text-indigo-600 rounded-lg text-xs font-bold hover:bg-indigo-100">
            Ir
          </button>
        </div>
      </div>
    </div>

    <!-- MODAL -->
    <Teleport to="body">
      <div v-if="showModal" class="fixed inset-0 bg-black/60 backdrop-blur-sm flex items-center justify-center p-3 md:p-4 z-[9999] overflow-y-auto" @click.self="showModal = false">
        <div class="bg-white dark:bg-gray-800 w-full max-w-md md:max-w-lg rounded-2xl shadow-2xl overflow-hidden animate-zoomIn my-auto max-h-[95vh] overflow-y-auto">
          <div class="bg-gradient-to-r from-indigo-600 to-purple-600 px-4 md:px-6 py-3 md:py-4 flex items-center gap-3 sticky top-0 z-10">
            <div class="p-1.5 md:p-2 bg-white/20 rounded-xl flex-shrink-0">
              <Icon :icon="isEditing ? 'mdi:pencil' : 'mdi:plus-circle'" class="text-white text-lg md:text-xl" />
            </div>
            <div class="flex-1 min-w-0">
              <h3 class="text-sm md:text-base font-bold text-white truncate">{{ isEditing ? 'Editar Tipo' : 'Nuevo Tipo de Membresía' }}</h3>
            </div>
            <button @click="showModal = false" class="p-1.5 bg-white/10 hover:bg-white/20 rounded-lg transition-all flex-shrink-0">
              <Icon icon="mdi:close" class="text-white text-lg md:text-xl" />
            </button>
          </div>

          <form @submit.prevent="guardar" class="p-4 md:p-6 space-y-3 md:space-y-4">
            <div class="grid grid-cols-2 gap-3">
              <div>
                <label class="block text-[10px] md:text-xs font-black text-gray-400 uppercase mb-1 ml-1">Código *</label>
                <input v-model="form.codigo" type="text" required maxlength="20" placeholder="MEN"
                  class="w-full px-3 py-2.5 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-xl text-sm text-gray-800 dark:text-white focus:ring-2 focus:ring-indigo-500 uppercase" />
              </div>
              <div>
                <label class="block text-[10px] md:text-xs font-black text-gray-400 uppercase mb-1 ml-1">Días *</label>
                <input v-model.number="form.duracion_dias" type="number" min="1" required
                  class="w-full px-3 py-2.5 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-xl text-sm text-gray-800 dark:text-white focus:ring-2 focus:ring-indigo-500" />
              </div>
            </div>

            <div>
              <label class="block text-[10px] md:text-xs font-black text-gray-400 uppercase mb-1 ml-1">Nombre *</label>
              <input v-model="form.nombre" type="text" required placeholder="Mensual"
                class="w-full px-3 py-2.5 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-xl text-sm text-gray-800 dark:text-white focus:ring-2 focus:ring-indigo-500" />
            </div>

            <div>
              <label class="block text-[10px] md:text-xs font-black text-gray-400 uppercase mb-1 ml-1">Descripción</label>
              <textarea v-model="form.descripcion" rows="2" placeholder="Acceso ilimitado..."
                class="w-full px-3 py-2.5 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-xl text-sm text-gray-800 dark:text-white focus:ring-2 focus:ring-indigo-500 resize-none"></textarea>
            </div>

            <div class="grid grid-cols-2 gap-3">
              <div>
                <label class="block text-[10px] md:text-xs font-black text-gray-400 uppercase mb-1 ml-1">Precio USD</label>
                <div class="relative">
                  <span class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 font-bold">$</span>
                  <input v-model.number="form.precio_usd" type="number" step="0.01" min="0" placeholder="0.00"
                    class="w-full pl-7 pr-3 py-2.5 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-xl text-sm text-gray-800 dark:text-white focus:ring-2 focus:ring-indigo-500" />
                </div>
              </div>
              <div>
                <label class="block text-[10px] md:text-xs font-black text-gray-400 uppercase mb-1 ml-1 flex items-center gap-1">
                  Precio Bs
                  <span v-if="tasaVenta" class="text-[9px] text-emerald-500 font-bold normal-case">
                    auto ×{{ formatBs(tasaVenta.precio_usd_bs) }}
                  </span>
                  <span v-else-if="cargandoTasa" class="text-[9px] text-gray-400 font-normal normal-case">cargando...</span>
                </label>
                <div class="relative">
                  <span class="absolute left-3 top-1/2 -translate-y-1/2 text-gray-500 font-bold text-xs">Bs</span>
                  <input v-model.number="form.precio_bs" type="number" step="0.01" min="0" placeholder="0.00"
                    class="w-full pl-10 pr-3 py-2.5 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-xl text-sm text-gray-800 dark:text-white focus:ring-2 focus:ring-indigo-500" />
                </div>
              </div>
            </div>

            <div v-if="tasaVenta" class="bg-emerald-50 dark:bg-emerald-900/20 rounded-xl p-2.5 border border-emerald-200 dark:border-emerald-800">
              <p class="text-[10px] text-emerald-700 dark:text-emerald-400 flex items-center gap-1.5">
                <Icon icon="mdi:currency-usd" class="text-sm" />
                <span class="font-bold">Tasa actual:</span>
                Bs {{ formatBs(tasaVenta.precio_usd_bs) }} por USD
                <span v-if="tasaVenta.nombreFuente" class="text-emerald-600 dark:text-emerald-500">
                  ({{ tasaVenta.nombreFuente }})
                </span>
              </p>
            </div>
            <div v-else-if="!cargandoTasa" class="bg-amber-50 dark:bg-amber-900/20 rounded-xl p-2.5 border border-amber-200 dark:border-amber-800">
              <p class="text-[10px] text-amber-700 dark:text-amber-400 flex items-center gap-1.5">
                <Icon icon="mdi:alert" class="text-sm" />
                No hay tasa de venta activa. Ingresa el precio en Bs manualmente.
              </p>
            </div>

            <div class="grid grid-cols-2 gap-3">
              <div>
                <label class="block text-[10px] md:text-xs font-black text-gray-400 uppercase mb-1 ml-1">Hora inicio</label>
                <input v-model="form.horario_inicio" type="time"
                  class="w-full px-3 py-2.5 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-xl text-sm text-gray-800 dark:text-white focus:ring-2 focus:ring-indigo-500" />
              </div>
              <div>
                <label class="block text-[10px] md:text-xs font-black text-gray-400 uppercase mb-1 ml-1">Hora fin</label>
                <input v-model="form.horario_fin" type="time"
                  class="w-full px-3 py-2.5 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-xl text-sm text-gray-800 dark:text-white focus:ring-2 focus:ring-indigo-500" />
              </div>
            </div>

            <div>
              <label class="block text-[10px] md:text-xs font-black text-gray-400 uppercase mb-1 ml-1">Límite accesos/día (dejar vacío = ilimitado)</label>
              <input v-model.number="form.limite_accesos_dia" type="number" min="1" placeholder="Ilimitado"
                class="w-full px-3 py-2.5 bg-gray-50 dark:bg-gray-700 border border-gray-200 dark:border-gray-600 rounded-xl text-sm text-gray-800 dark:text-white focus:ring-2 focus:ring-indigo-500" />
            </div>

            <div class="flex items-center gap-2 px-1">
              <input v-model="form.tiene_acceso_torniquete" type="checkbox" id="chk-torniquete" class="w-4 h-4 rounded text-indigo-600" />
              <label for="chk-torniquete" class="text-sm font-bold text-gray-700 dark:text-gray-300">Permite acceso al torniquete</label>
            </div>

            <div class="flex flex-col sm:flex-row gap-3 pt-3 md:pt-4 border-t border-gray-100 dark:border-gray-700">
              <button type="button" @click="showModal = false"
                class="flex-1 py-2.5 bg-gray-100 dark:bg-gray-700 text-gray-600 dark:text-gray-300 rounded-xl font-bold text-sm hover:bg-gray-200 transition-all">
                Cancelar
              </button>
              <button type="submit" :disabled="guardando"
                class="flex-[2] bg-gradient-to-r from-indigo-600 to-purple-600 text-white py-2.5 rounded-xl font-bold text-sm hover:opacity-90 transition-all shadow-lg flex items-center justify-center gap-2 disabled:opacity-50">
                <Icon :icon="guardando ? 'mdi:loading' : 'mdi:content-save'" :class="{'animate-spin': guardando}" class="text-lg" />
                {{ guardando ? 'Guardando...' : (isEditing ? 'Actualizar' : 'Crear Tipo') }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script setup>
import { ref, reactive, computed, onMounted, watch } from 'vue';
import { Icon } from '@iconify/vue';
import Swal from 'sweetalert2';
import {
  obtenerTiposMembresia,
  crearTipoMembresia,
  actualizarTipoMembresia,
  eliminarTipoMembresia
} from '@/api/membresias';
import { obtenerTasaVentaActual, obtenerTasasVenta } from '@/api/tasaVenta';

const tipos = ref([]);
const cargando = ref(false);
const guardando = ref(false);
const showModal = ref(false);
const isEditing = ref(false);

const tasaVenta = ref(null);
const cargandoTasa = ref(false);

// Filtros y paginación
const filtroBusqueda = ref('');
const filtroEstado = ref('');
const paginaActual = ref(1);
const itemsPorPagina = ref(6);
const irAPagina = ref(1);

const form = reactive({
  idTipoMembresia: null,
  codigo: '',
  nombre: '',
  descripcion: '',
  duracion_dias: 30,
  precio_usd: 0,
  precio_bs: 0,
  tiene_acceso_torniquete: true,
  limite_accesos_dia: null,
  horario_inicio: '',
  horario_fin: '',
  estado: 'activo'
});

const swalBase = {
  heightAuto: false,
  backdrop: 'rgba(0,0,0,0.6)',
  customClass: {
    popup: 'rounded-2xl',
    cancelButton: 'swal-cancel-btn'
  },
  buttonsStyling: false
};

const toast = {
  success: (m) => Swal.fire({
    toast: true, position: 'top-end', showConfirmButton: false,
    timer: 3000, timerProgressBar: true, icon: 'success', title: m,
    heightAuto: false
  }),
  error: (m) => Swal.fire({
    toast: true, position: 'top-end', showConfirmButton: false,
    timer: 4000, timerProgressBar: true, icon: 'error', title: m,
    heightAuto: false
  })
};

const formatBs = (valor) => {
  const num = parseFloat(valor) || 0;
  return num.toLocaleString('es-VE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

const formatUsd = (valor) => {
  const num = parseFloat(valor) || 0;
  return num.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
};

// COMPUTED: filtros y paginación
const tiposFiltrados = computed(() => {
  let lista = [...tipos.value];
  if (filtroBusqueda.value.trim()) {
    const q = filtroBusqueda.value.toLowerCase().trim();
    lista = lista.filter(t =>
      (t.codigo || '').toLowerCase().includes(q) ||
      (t.nombre || '').toLowerCase().includes(q) ||
      (t.descripcion || '').toLowerCase().includes(q)
    );
  }
  if (filtroEstado.value) {
    lista = lista.filter(t => (t.estado || 'activo') === filtroEstado.value);
  }
  return lista;
});

const totalPaginas = computed(() => Math.max(1, Math.ceil(tiposFiltrados.value.length / itemsPorPagina.value)));

const tiposPaginados = computed(() => {
  const inicio = (paginaActual.value - 1) * itemsPorPagina.value;
  return tiposFiltrados.value.slice(inicio, inicio + itemsPorPagina.value);
});

const rangoInicio = computed(() => tiposFiltrados.value.length === 0 ? 0 : (paginaActual.value - 1) * itemsPorPagina.value + 1);
const rangoFin = computed(() => Math.min(paginaActual.value * itemsPorPagina.value, tiposFiltrados.value.length));

const paginasVisibles = computed(() => {
  const total = totalPaginas.value;
  const actual = paginaActual.value;
  const resultado = [];
  if (total <= 7) {
    for (let i = 1; i <= total; i++) resultado.push({ numero: i });
    return resultado;
  }
  resultado.push({ numero: 1 });
  if (actual > 3) resultado.push({ numero: '...' });
  const inicio = Math.max(2, actual - 1);
  const fin = Math.min(total - 1, actual + 1);
  for (let i = inicio; i <= fin; i++) resultado.push({ numero: i });
  if (actual < total - 2) resultado.push({ numero: '...' });
  resultado.push({ numero: total });
  return resultado;
});

const saltarAPagina = () => {
  const p = parseInt(irAPagina.value);
  if (p >= 1 && p <= totalPaginas.value) paginaActual.value = p;
  else irAPagina.value = paginaActual.value;
};

watch([filtroBusqueda, filtroEstado, itemsPorPagina], () => {
  paginaActual.value = 1;
  irAPagina.value = 1;
});

watch(paginaActual, (nueva) => { irAPagina.value = nueva; });

const normalizarTipo = (t) => ({
  idTipoMembresia: t.idTipoMembresia ?? t.IdTipoMembresia,
  codigo: t.codigo ?? t.Codigo ?? '',
  nombre: t.nombre ?? t.Nombre ?? '',
  descripcion: t.descripcion ?? t.Descripcion ?? '',
  duracion_dias: t.duracion_dias ?? t.DuracionDias ?? 30,
  precio_usd: parseFloat(t.precio_usd ?? t.PrecioUsd ?? 0),
  precio_bs: parseFloat(t.precio_bs ?? t.PrecioBs ?? 0),
  tiene_acceso_torniquete: t.tiene_acceso_torniquete ?? t.TieneAccesoTorniquete ?? true,
  limite_accesos_dia: t.limite_accesos_dia ?? t.LimiteAccesosDia ?? null,
  horario_inicio: t.horario_inicio ?? t.HorarioInicio ?? '',
  horario_fin: t.horario_fin ?? t.HorarioFin ?? '',
  estado: t.estado ?? t.Estado ?? 'activo'
});

const cargarTasaVenta = async () => {
  cargandoTasa.value = true;
  try {
    const res = await obtenerTasaVentaActual();
    if (res.success && res.data) {
      tasaVenta.value = res.data;
    } else {
      const res2 = await obtenerTasasVenta('activas');
      if (res2.success && res2.data && res2.data.length > 0) {
        tasaVenta.value = res2.data[0];
      } else {
        tasaVenta.value = null;
      }
    }
  } catch (e) {
    console.error('❌ Error cargando tasa:', e);
    tasaVenta.value = null;
  } finally {
    cargandoTasa.value = false;
  }
};

const cargar = async () => {
  cargando.value = true;
  try {
    const res = await obtenerTiposMembresia();
    if (res.success) {
      let lista = res.data;
      if (lista && !Array.isArray(lista) && Array.isArray(lista.data)) lista = lista.data;
      if (lista && !Array.isArray(lista) && Array.isArray(lista.items)) lista = lista.items;
      if (!Array.isArray(lista)) lista = [];
      tipos.value = lista.map(normalizarTipo);
    } else {
      toast.error(res.error || 'Error al cargar');
    }
  } catch (e) {
    console.error('❌ Excepción cargando tipos:', e);
    toast.error('Error al cargar tipos');
  } finally {
    cargando.value = false;
  }
};

const openCreateModal = () => {
  isEditing.value = false;
  Object.assign(form, {
    idTipoMembresia: null, codigo: '', nombre: '', descripcion: '',
    duracion_dias: 30, precio_usd: 0, precio_bs: 0,
    tiene_acceso_torniquete: true, limite_accesos_dia: null,
    horario_inicio: '', horario_fin: '', estado: 'activo'
  });
  showModal.value = true;
};

const openEditModal = (t) => {
  isEditing.value = true;
  Object.assign(form, t);
  showModal.value = true;
};

const guardar = async () => {
  guardando.value = true;
  try {
    const payload = {
      ...form,
      horario_inicio: form.horario_inicio || null,
      horario_fin: form.horario_fin || null,
      precio_usd: parseFloat(form.precio_usd) || 0,
      precio_bs: parseFloat(form.precio_bs) || 0
    };
    const res = isEditing.value
      ? await actualizarTipoMembresia(form.idTipoMembresia, payload)
      : await crearTipoMembresia(payload);

    if (res.success) {
      toast.success(isEditing.value ? 'Tipo actualizado' : 'Tipo creado');
      showModal.value = false;
      await cargar();
    } else {
      toast.error(res.error || 'Error al guardar');
    }
  } catch (e) {
    console.error('❌ Error guardando:', e);
    toast.error('Error inesperado al guardar');
  } finally {
    guardando.value = false;
  }
};

// ⭐ CONFIRMAR Y CAMBIAR ESTADO (ACTIVAR / DESACTIVAR)
const confirmToggleEstado = async (t) => {
  const esActivo = t.estado === 'activo';

  const r = await Swal.fire({
    ...swalBase,
    title: esActivo ? '¿Desactivar tipo?' : '¿Activar tipo?',
    html: esActivo
      ? `Se desactivará <b>"${t.nombre}"</b><br><span style="font-size:0.75rem;color:#6b7280">Los socios con este plan no podrán renovar</span>`
      : `Se activará <b>"${t.nombre}"</b><br><span style="font-size:0.75rem;color:#6b7280">Volverá a estar disponible para asignar</span>`,
    icon: esActivo ? 'warning' : 'question',
    showCancelButton: true,
    confirmButtonText: esActivo ? 'Sí, desactivar' : 'Sí, activar',
    cancelButtonText: 'Cancelar',
    reverseButtons: true,
    focusCancel: true,
    customClass: {
      popup: 'rounded-2xl',
      confirmButton: esActivo ? 'swal-confirm-danger' : 'swal-confirm-success',
      cancelButton: 'swal-cancel-btn'
    }
  });

  if (!r.isConfirmed) return;

  if (esActivo) {
    // Desactivar
    const res = await eliminarTipoMembresia(t.idTipoMembresia);
    if (res.success) {
      toast.success('Tipo desactivado');
      await cargar();
    } else {
      toast.error(res.error || 'Error al desactivar');
    }
  } else {
    // Activar → actualizamos estado a 'activo'
    const res = await actualizarTipoMembresia(t.idTipoMembresia, {
      ...t,
      estado: 'activo'
    });
    if (res.success) {
      toast.success('Tipo activado');
      await cargar();
    } else {
      toast.error(res.error || 'Error al activar');
    }
  }
};

watch(() => form.precio_usd, (nuevoUsd) => {
  if (tasaVenta.value && tasaVenta.value.precio_usd_bs) {
    const usd = parseFloat(nuevoUsd) || 0;
    form.precio_bs = Number((usd * tasaVenta.value.precio_usd_bs).toFixed(2));
  }
});

onMounted(async () => {
  await cargarTasaVenta();
  await cargar();
});
</script>

<style scoped>
.animate-zoomIn { animation: zoomIn 0.2s ease-out; }
@keyframes zoomIn { from { opacity: 0; transform: scale(0.95); } to { opacity: 1; transform: scale(1); } }
.line-clamp-2 { display: -webkit-box; -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden; }
</style>

<!-- 🌍 ESTILOS GLOBALES PARA SWEETALERT2 -->
<style>
.swal2-popup {
  border-radius: 1rem !important;
  padding: 1.5rem !important;
  font-family: inherit !important;
}
.swal2-actions {
  gap: 0.75rem !important;
  margin-top: 1.25rem !important;
}

/* ✅ Botón VERDE (activar) */
.swal-confirm-success {
  background: linear-gradient(135deg, #059669, #10b981) !important;
  color: white !important;
  padding: 0.65rem 1.5rem !important;
  border-radius: 0.75rem !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  border: none !important;
  cursor: pointer !important;
  transition: all 0.2s !important;
  box-shadow: 0 4px 6px -1px rgba(5, 150, 105, 0.3) !important;
}
.swal-confirm-success:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 6px 12px -2px rgba(5, 150, 105, 0.4) !important;
}

/* ❌ Botón ROJO (desactivar) */
.swal-confirm-danger {
  background: linear-gradient(135deg, #dc2626, #e11d48) !important;
  color: white !important;
  padding: 0.65rem 1.5rem !important;
  border-radius: 0.75rem !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  border: none !important;
  cursor: pointer !important;
  transition: all 0.2s !important;
  box-shadow: 0 4px 6px -1px rgba(220, 38, 38, 0.3) !important;
}
.swal-confirm-danger:hover {
  transform: translateY(-1px) !important;
  box-shadow: 0 6px 12px -2px rgba(220, 38, 38, 0.4) !important;
}

/* Cancelar */
.swal-cancel-btn {
  background: #f3f4f6 !important;
  color: #374151 !important;
  padding: 0.65rem 1.5rem !important;
  border-radius: 0.75rem !important;
  font-weight: 700 !important;
  font-size: 0.875rem !important;
  border: 1px solid #e5e7eb !important;
  cursor: pointer !important;
  transition: all 0.2s !important;
}
.swal-cancel-btn:hover {
  background: #e5e7eb !important;
}

/* Dark mode */
.dark .swal2-popup { background: #1f2937 !important; color: #f3f4f6 !important; }
.dark .swal2-title { color: #f3f4f6 !important; }
.dark .swal2-html-container { color: #9ca3af !important; }
.dark .swal-cancel-btn { background: #374151 !important; color: #e5e7eb !important; border-color: #4b5563 !important; }
.dark .swal-cancel-btn:hover { background: #4b5563 !important; }
</style>